export class MockI18nService {
  currentLocale = 'en-US';
}
